var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"g-alert fluid-container",class:_vm.classes},[_c('i',{staticClass:"g-alert-icon g-icon g-icon-close-a",on:{"click":_vm.clearStatusMessage}}),_c('div',{staticClass:"g-alert-content"},[_vm._v(" "+_vm._s(_vm.statusMessage.body)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }